// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import WidgetRow from '@Organisms/Dashboard/DashboardDetails/WidgetRow/WidgetRow';
import { useDashboard } from '@Hooks/useDashboard';
import DropableWidgetRow from '@Organisms/Dashboard/DashboardDetails/DropableWidgetRow/DropableWidgetRow';
import DropableWidgetRowList from '@Organisms/Dashboard/DashboardDetails/DropableWidgetRowList/DropableWidgetRowList';
import { moveElementOnArray } from '@Helpers/';
import { DashboardDropRowResult } from '@Types';

import './WidgetRowList.scss';

const WidgetRowList = (): ReactElement => {
    const { dashboard, editMode, setRows } = useDashboard();

    const { items: rows } = dashboard.definition;

    const moveRow = (dropResult: DashboardDropRowResult, draggedRowIndex: number): void => {
        const { hoveredRowIndex } = dropResult || {};
        setRows(moveElementOnArray(rows, draggedRowIndex, hoveredRowIndex));
    };

    return (
        <div className="widget-row-list">
            {editMode ? (
                <DropableWidgetRowList>
                    {rows.map((row, index) => (
                        <DropableWidgetRow
                            rowIndex={index}
                            key={index}
                            moveRow={(dropResult): void => moveRow(dropResult, index)}
                        >
                            <WidgetRow row={row} rowIndex={index} />
                        </DropableWidgetRow>
                    ))}
                </DropableWidgetRowList>
            ) : (
                rows.map((row, index) => <WidgetRow key={'row' + index} row={row} rowIndex={index} />)
            )}
        </div>
    );
};

export default WidgetRowList;
